<script setup>
import { ref, onMounted, watch, computed } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { useStore } from 'vuex';
import { useScreenSize } from '@/composables/useScreenSize';

import PFHelpComponent from '@/components/common/PFHelpComponent';
import PFSearchBarComponent from '@/components/common/PFSearchBarComponent/PFSearchBarComponent.vue';
import PFSiteLogoComponent from '@/components/common/PFSiteLogoComponent';
import PFUserProfileComponent from '@/components/common/PFUserProfileComponent';

const IE_BROWSER_PAGE = 'browserNotSupportedPage';

const props = defineProps({
  title: { type: String },
});

const removeSearchBar = ref(true);

const store = useStore();
const router = useRouter();
const route = useRoute();

const { isScreenSizeLessMD } = useScreenSize();

const shouldShowSearchBar = computed(() => {
  return !removeSearchBar.value && !showSearchBarInHeader();
});

function showSearchBarInHeader() {
  return route.path === '/' || route.path.includes('editor');
}

function isEditorPageHeader() {
  return route.path.includes('editor') || route.path.includes('partner-terms-of-use');
}

watch(
  isScreenSizeLessMD,
  (newValue) => {
    store.commit('solutionL2Store/setMobileMode', newValue);
  },
  { immediate: true }
);

onMounted(() => {
  if (router.currentRoute.value.name !== IE_BROWSER_PAGE) {
    removeSearchBar.value = false;
  }
  store.dispatch('systemMaintenance/fetchActiveMaintenanceData');
});
</script>

<template>
  <div class="bg-grey-1 h-fit w-full px-6 sm:px-12 md:px-18" id="pf-page-header">
    <div class="mx-auto max-w-[1432px]">
      <div class="grid grid-cols-2 md:grid-rows-1 grid-rows-[auto_auto] items-center"
        :style="{ 'grid-template-columns': isScreenSizeLessMD ? '1fr 1fr' : 'auto auto auto' }"> 

        <!-- Logo -->
        <div class="my-[0.8px] col-start-1 row-start-1 w-fit">
          <PFSiteLogoComponent :title="title" :editorHeader="isEditorPageHeader()" :blackHeaderLogo="true" />
        </div>

        <!-- User controls -->
        <div class="flex justify-end col-start-2 md:col-start-3 row-start-1 items-center" v-if="!removeSearchBar">
            <PFHelpComponent />
            <PFUserProfileComponent />
        </div>

        <!-- Search bar -->
        <div v-if="shouldShowSearchBar"
          class="col-span-2 md:col-span-1 col-start-1 md:col-start-2 row-start-2 md:row-start-1 mb-2 md:mb-0 md:w-[454px] xl:w-[568px] md:justify-self-center">
          <PFSearchBarComponent />
        </div>
      </div>
    </div>
  </div>
</template>